import { ref } from 'vue'

import { log } from '@js/utils/logger'
import useAuth from '@js/composables/useAuth'
import useCart from '@js/composables/useCart'
import { checkoutLinks } from '@js/utils/links'

export default function useCourseRegistration() {
  const { addItemToCart } = useCart()
  const { setLastRegistration } = useAuth()

  const courseSKU = ref('')
  const courseOption = ref('')
  const craftEntryId = ref(0)
  const wasRedirectedFromCourseRegister = ref(false)

  const setSkuAndCourseOption = (): void => {
    const urlParams = new URLSearchParams(window.location.search)
    const sku = urlParams.get('sku')
    const option = urlParams.get('course_option')
    const entryId = urlParams.get('craft_entry_id')

    if (sku && option) {
      courseSKU.value = sku
      courseOption.value = option
      craftEntryId.value = entryId ? Number(entryId) : 0
      wasRedirectedFromCourseRegister.value = true

      if (!entryId || Number.isNaN(craftEntryId.value) || craftEntryId.value <= 0) {
        log({
          message: `Missing or invalid craft_entry_id in redirect URL for sku "${sku}". Registration will be created with an incorrect craft_entry_id and its course will not display on the dashboard.`,
          file: 'src/wcei/js/composables/useCourseRegistration.ts',
        })
      }
    }
  }

  const handleRedirectFromCourseRegister = async (): Promise<void> => {
    const result = await addItemToCart(courseSKU.value, courseOption.value, craftEntryId.value)

    if (result.status === 'success') {
      setLastRegistration(result.data.registration_id)
      window.location.assign(checkoutLinks.CHECKOUT)
    } else {
      log({
        message: 'Item could not be added to the cart',
        file: 'src/wcei/js/composables/useCourseRegistration.ts',
      })
    }
  }

  return {
    courseSKU,
    courseOption,
    craftEntryId,
    setSkuAndCourseOption,
    wasRedirectedFromCourseRegister,
    handleRedirectFromCourseRegister,
  }
}
